const constants = {
  url: process.env.VUE_APP_url,
  s3Bucket: process.env.VUE_APP_s3Bucket,
  loginServiceUrl: process.env.VUE_APP_loginServiceUrl,
  editorUrl: process.env.VUE_APP_editorUrl,
  apiHost: process.env.VUE_APP_apiHost,
  baseApiUrl: process.env.VUE_APP_baseApiUrl,
};

export default constants;
